export const themePageCountryAnaly = {
    title:
        'Select up to 5 countries to compare. The clusters to which the selected countries belong will be displayed, allowing you to compare scores and other metrics.',
    metric: 'Indicative Data',
    select1: 'Score (Technological Competitiveness)',
    select2: 'Score (Average)',
    select3: 'Number of Patent Applications',
    select4: 'Citations (Total)',
    select5: 'Citations Average (Patent-Based)',
    select6: 'Citations Average (Company-Based)',
    select7: 'Citations (Top-N Average)',
    select8: 'Key Patents',
    select9: 'Key Patent Ratio',
    topNModePercent: 'Percentage (%)',
    topNModeCount: 'Fixed Number',
    topNUnitCompany: 'companies',
    countryPlaceholder: 'Enter a country name (English)',
    countryName: 'Select a Country',
    tableColumn1: 'Cluster ID',
    tableColumn2: 'Cluster Name',
    noDataMsg: 'This countries does not have this cluster data'
}
